import InfoBlockComponentPluginFactory from './InfoBlockComponentPluginFactory';

export const InfoBlockComponentPlugin = InfoBlockComponentPluginFactory(
  'infoBlock',
  'Info block'
);
export const NoteBlockComponentPlugin = InfoBlockComponentPluginFactory(
  'noteBlock',
  'Note block'
);
export const WarningBlockComponentPlugin = InfoBlockComponentPluginFactory(
  'warningBlock',
  'Warning block'
);
export const TipBlockComponentPlugin = InfoBlockComponentPluginFactory(
  'tipBlock',
  'Tip block'
);

// For legacy reasons the different info blocks are represented as types
// rather than as an attribute on the element.
const InfoBlockPlugin = [
  ...InfoBlockComponentPlugin,
  ...NoteBlockComponentPlugin,
  ...WarningBlockComponentPlugin,
  ...TipBlockComponentPlugin,
];

export default InfoBlockPlugin;
